import {
  Checkbox,
  CheckboxProps,
  FormControl,
  FormControlLabel,
  FormControlProps,
} from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

export type FormCheckboxProps = Omit<
  FormControlProps,
  'required' | 'defaultValue' | 'name'
> & {
  label: string;
  required?: boolean | string;
  checkboxProps?: Partial<CheckboxProps>;
  name: string;
  rules?: Record<string, unknown>;
};

export const FormCheckbox = (props: FormCheckboxProps) => {
  const {
    name,
    label,
    required,
    checkboxProps,
    variant = 'standard',
    children,
    rules,
    ...rest
  } = props;
  const { control, formState } = useFormContext();
  const errorMsg = formState.errors[name]?.message;
  const hasErrorMsg = typeof errorMsg === 'string';

  return (
    <FormControl variant={variant} {...rest} error={hasErrorMsg}>
      <Controller
        name={name}
        control={control}
        rules={{
          ...rules,
          required,
        }}
        render={({ field }) => (
          <FormControlLabel
            label={label}
            control={
              <Checkbox
                {...checkboxProps}
                {...field}
                checked={Boolean(field.value)}
                onChange={(event, checked) => {
                  field.onChange(checked);
                  checkboxProps?.onChange?.(event, checked);
                }}
              />
            }
          />
        )}
      />
    </FormControl>
  );
};
